import React from "react";
type Props = {
  width?: number | string;
  height?: number | string;
  title?: string; // for accessibility; if omitted, aria-hidden will be true
  className?: string;
  style?: React.CSSProperties;
  strokeWidth?: number;
  pathFill?:string;
};
export const FavoriteSvg: React.FC<Props> = ({
  width = 24,
  height = 24,
  title,
  className,
  style,
  strokeWidth = 1.8,
  pathFill = '#ffdc00'
}) => {
  const labelled = Boolean(title);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      className={className}
      style={style}
      role={labelled ? "img" : undefined}
      aria-label={labelled ? title : undefined}
      aria-hidden={labelled ? undefined : true}
      fill="none"
    >
      {title ? <title>{title}</title> : null}
      {/* Heart path (material-like) */}
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        fill={pathFill}
        stroke="#000"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
};